export const buildProductImageUrl = (relativeUrl) => {
  if (!relativeUrl) return null;
  if (relativeUrl.startsWith('http://') || relativeUrl.startsWith('https://')) {
    return relativeUrl;
  }
  if (relativeUrl.startsWith('data:')) {
    return relativeUrl;
  }

  let backendOrigin = window.location.origin;

  if (process.env.REACT_APP_API_PRODUCTS_IMAGES_GET_ROUTE) {
    try {
      const url = new URL(process.env.REACT_APP_API_PRODUCTS_IMAGES_GET_ROUTE);
      backendOrigin = url.origin;
    } catch (e) {
      console.warn('No se pudo extraer el origin del backend, usando origin actual');
    }
  }

  if (relativeUrl.startsWith('/')) {
    return `${backendOrigin}${relativeUrl}`;
  }
  return relativeUrl;
};

const getOptimizedVariant = (optimizedImage, variant = 'thumbnail') => {
  if (!optimizedImage) return null;
  if (optimizedImage[variant]) return optimizedImage[variant];

  // Para detalle: medium como respaldo de large, nunca thumbnail (pixela al ampliar)
  if (variant === 'large' && optimizedImage.medium) {
    return optimizedImage.medium;
  }
  if (variant === 'medium' && optimizedImage.thumbnail) {
    return optimizedImage.thumbnail;
  }

  return null;
};

export const getProductImageSources = (product, variant = 'thumbnail') => {
  const hasBase64Image = product?.image && product.image.startsWith('data:');
  const optimizedVariant = getOptimizedVariant(product?.optimizedImage, variant);

  const optimizedImageUrls = optimizedVariant ? {
    jpg: buildProductImageUrl(optimizedVariant.jpg),
    webp: buildProductImageUrl(optimizedVariant.webp),
    avif: optimizedVariant.avif ? buildProductImageUrl(optimizedVariant.avif) : null,
  } : null;

  const imageUrl = hasBase64Image
    ? product.image
    : (optimizedImageUrls?.jpg) || (product?.hasImage && product?.id
      ? `${process.env.REACT_APP_API_PRODUCTS_IMAGES_GET_ROUTE}${product.id}`
      : null);

  return {
    hasBase64Image,
    optimizedImageUrls,
    imageUrl,
    hasImage: imageUrl != null,
    hasOptimizedImage: optimizedImageUrls != null && !hasBase64Image,
  };
};
